import createErrorMessage from "@shared/factories/src/errorMessage.factory"
import * as addressApi from "../api/address.api"

export const fetchAddress = async postcode => {
  try {
    const { data } = await addressApi.fetchAddress(postcode)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Falha ao obter endereço."
    })
    throw error
  }
}

export const fetchAddressGroups = async params => {
  try {
    const { data } = await addressApi.fetchAddressGroups(params)
    return data[0].groups
  } catch (error) {
    console.error(error)
  }
}

export const saveAddress = async body => {
  try {
    const { data } = await addressApi.saveAddress(body)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao salvar dados do endereço."
    })
    throw error
  }
}

export const listCities = async params => {
  try {
    const { data } = await addressApi.listCities(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao obter cidades disponíveis."
    })
  }
}

export const fetchAddressComplements = async params => {
  try {
    const data = await addressApi.fetchAddressComplements(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.message ||
        "Falha ao buscar os complementos de endereços."
    })
    throw error
  }
}

export const fetchAddressByUserPosition = async params => {
  try {
    const data = await addressApi.fetchAddressByUserPosition(params)
    return data
  } catch (error) {
    console.error(error)
  }
}

export const fetchCondominiumOptions = async params => {
  try {
    const data = await addressApi.fetchCondominiumOptions(params)
    return data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const fetchAllCondominiumOptions = async params => {
  try {
    const data = await addressApi.fetchAllCondominiumOptions(params)
    return data
  } catch (error) {
    console.error(error)
    throw error
  }
}